import { useQuery } from '@tanstack/react-query';
import { DepartmentSectionsParams, getDepartmentSections } from '../apis/department';

export const useDepartmentSectionsQuery = (params: DepartmentSectionsParams) => {
  return useQuery({
    queryKey: [
      'department-sections',
      params.city,
      params.departmentSectionTypeId,
      params.limit,
      params.offset,
    ],
    queryFn: () => getDepartmentSections(params),
    retry: false,
    staleTime: 300000,
  });
};
